import CardShoppingCart from "./CardShoppingCart";
import "./CardsListShoppingCart.css";
import "../../AceternityForm/AceternityForm.css";
import {
  aceternityTextFieldSx,
  aceternitySelectSx,
  aceternityMenuPaperSx,
} from "../../AceternityForm/aceternityTextFieldSx";
import { Button, Divider, MenuItem, Select, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Box } from "@mui/material";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import React, { useEffect, useState } from "react";
import { useUser } from "../../../Context/UserContext";
import { getOrderProducts, getOrders } from "../../../services/getOrders";
import {
  addCRShippingCost,
  applyDiscountToOrder,
  createShoppingCart,
  getOrderTotal,
  migrateDraftToNewOrder,
  updateOrderData,
  validateOrder,
} from "../../../services/posOrders";
import { fetchImage } from "../../../services/getProducts";

function displayThisSection(displayThis, isEmptyBlock, listSize) {
  if (displayThis === 1 && (listSize > 0) ^ isEmptyBlock) {
    return "flex";
  } else {
    return "none";
  }
}

const CardListShoppingCart = (props) => {
  const [orderId, setOrderId] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  const [pickupLocation, setPickupLocation] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [showPaymentResult, setShowPaymentResult] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null); // 'success', 'failed', 'insufficient_funds'
  const [paymentMessage, setPaymentMessage] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  
  // Variables para los datos de TiloPay - ESTAS SON LAS VARIABLES QUE NECESITAS
  const [tiloPayName, setTiloPayName] = useState("");
  const [tiloPayLastName, setTiloPayLastName] = useState("");
  const [tiloPayEmail, setTiloPayEmail] = useState("");
  const [tiloPayAddress, setTiloPayAddress] = useState("");
  const [tiloPayProvince, setTiloPayProvince] = useState("");
  const [tiloPayPostalCode, setTiloPayPostalCode] = useState("");
  
  const { user, setUser } = useUser();

  // Provincias de Costa Rica
  const costaRicanProvinces = [
    "San José",
    "Alajuela", 
    "Cartago",
    "Heredia",
    "Guanacaste",
    "Puntarenas",
    "Limón"
  ];

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [setUser]);

  // Llenar email automáticamente cuando se carga el usuario
  useEffect(() => {
    if (user?.email && !tiloPayEmail) {
      setTiloPayEmail(user.email);
    }
  }, [user, tiloPayEmail]);

  //console.log("User:", user);

  useEffect(() => {
    if (user?.id) {
      getOrders(user.id).then((result) => {
        if (result.draftOrders.length > 0) {
          const currentOrder = result.draftOrders[0];
          setOrderId(currentOrder.orderId);

          getOrderProducts(currentOrder.orderId).then(async (orderProducts) => {
            const productsWithImages = await Promise.all(
              orderProducts.map(async (product) => {
                const imageUrl = await fetchImage(product.id);
                return { ...product, imageUrl };
              })
            );
            setOrderLines(productsWithImages);
          });
        }
      });
    }
  }, [user]);

  // Detectar cuando regresa de TiloPay
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const orderNumber = urlParams.get("order");  // TiloPay orderNumber
    const description = urlParams.get("description");
    const wpCancel = urlParams.get("wp_cancel"); // Detectar cancelación

    const draftOrderId = localStorage.getItem("draftOrderId");
    const pickupLocation = localStorage.getItem("pickupLocation");

    const finalizePayment = async () => {
      //if (!code || !orderNumber || !draftOrderId) return;
      if (!code && !wpCancel) return;

      if (code === "1") {
        // Solo si fue exitoso: migramos y validamos
        const newOrderId = await migrateDraftToNewOrder(
          draftOrderId,
          user.id,
          pickupLocation,
          "6" // pago con tarjeta
        );

        if (parseInt(pickupLocation) === 5) {
          await addCRShippingCost(newOrderId, {
            qty: "1",
            label: "+₡2500",
            subprice: "2500",
          });
        }

        await validateOrder(newOrderId);
        setOrderLines([]);
        setOrderId(null);

        setPaymentStatus("success");
        setPaymentMessage("Pago exitoso. Su orden ha sido procesada.");
      } else if (wpCancel === "yes") {
        // Cancelado por el usuario
        setPaymentStatus("failed");
        setPaymentMessage("Pago cancelado por el usuario.");
      } else {
        setPaymentStatus("failed");
        setPaymentMessage(`Transacción cancelada o fallida. Detalle: ${description || "N/A"}`);
      }

      setShowPaymentResult(true);
      localStorage.removeItem("draftOrderId");
      localStorage.removeItem("orderNumber");
      localStorage.removeItem("pickupLocation");
      window.history.replaceState({}, document.title, window.location.pathname);
    };

    if (user?.id) finalizePayment();
  }, [user]);

  const getDefaultMessage = (status) => {
    switch (status) {
      case 'success':
        return '¡Pago completado con éxito! Su orden ha sido procesada.';
      case 'failed':
        return 'El pago no pudo ser procesado. Intente nuevamente.';
      case 'insufficient_funds':
        return 'Fondos insuficientes. Verifique su saldo e intente nuevamente.';
      default:
        return 'Estado del pago desconocido.';
    }
  };

  const getShoppingCartTotalPrice = (productList) => {
    return productList.reduce(
      (total, product) => total + parseFloat(product.total_ttc),
      0
    );
  };

  const total = getShoppingCartTotalPrice(orderLines);

  const generateOrderNumber = (userId) => {
    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:TZ.]/g, "").slice(0, 14); // yyyyMMddHHmmss
    return `VOLTEON-${userId}-${timestamp}`;
  };

  // Validar formato de código postal costarricense (5 dígitos)
  const validatePostalCode = (code) => {
    return /^\d{5}$/.test(code);
  };

  // Validar campos de TiloPay
  const validateTiloPayFields = () => {
    if (!tiloPayName.trim()) {
      alert("Por favor, ingrese su nombre.");
      return false;
    }
    if (!tiloPayLastName.trim()) {
      alert("Por favor, ingrese su apellido.");
      return false;
    }
    if (!tiloPayEmail.trim()) {
      alert("Por favor, ingrese su correo electrónico.");
      return false;
    }
    if (!tiloPayAddress.trim()) {
      alert("Por favor, ingrese su dirección.");
      return false;
    }
    if (!tiloPayProvince) {
      alert("Por favor, seleccione su provincia.");
      return false;
    }
    if (!tiloPayPostalCode.trim()) {
      alert("Por favor, ingrese su código postal.");
      return false;
    }
    if (!validatePostalCode(tiloPayPostalCode)) {
      alert("El código postal debe tener exactamente 5 dígitos.");
      return false;
    }
    return true;
  };

  const handlePayment = async () => {
    if (isProcessingPayment) return; // evitar múltiples clics

    if (!pickupLocation || !paymentMethod) {
      alert("Por favor, seleccione un lugar de recogida y un método de pago antes de proceder.");
      return;
    }

    if (!orderId) {
      alert("No hay una orden activa.");
      return;
    }

    try {
      setIsProcessingPayment(true); // Desactiva botón

      if (paymentMethod === "6") {
        // Validar campos de TiloPay antes de proceder
        if (!validateTiloPayFields()) {
          setIsProcessingPayment(false);
          return;
        }

        // No migramos, solo generamos el número único y redirigimos
        const orderNumber = generateOrderNumber(user.id);

        // Guardamos info para usar al volver
        localStorage.setItem("orderNumber", orderNumber);
        localStorage.setItem("draftOrderId", orderId);
        localStorage.setItem("pickupLocation", pickupLocation);

        await handleTiloPayRedirect(orderNumber);
        return;
      }

      const newOrderId = await migrateDraftToNewOrder(
        orderId,
        user.id,
        pickupLocation,
        paymentMethod
      );

      if (parseInt(pickupLocation) === 5) {
        await addCRShippingCost(newOrderId, {
          qty: "1",
          label: "+₡2500",
          subprice: "2500",
        });
      }

      // Efectivo o SINPE
      await validateOrder(newOrderId);
      
      // Mostrar mensaje de éxito según el método de pago y punto de entrega
      let successMessage = "";
      if (paymentMethod === "106") { // SINPE
        if (parseInt(pickupLocation) === 5) {
          successMessage = "¡Pago con SINPE exitoso! Su pedido fue enviado por Correos de Costa Rica. Recibirá información de seguimiento pronto.";
        } else {
          successMessage = "¡Pago con SINPE exitoso! Su pedido estará listo para recoger en la asociación seleccionada en un máximo de 3 días.";
        }
      } else { // Efectivo
        if (parseInt(pickupLocation) === 5) {
          successMessage = "¡Pedido confirmado! Su pedido fue enviado por Correos de Costa Rica. El pago se realizará contra entrega.";
        } else {
          successMessage = "¡Pedido confirmado! Su pedido estará listo para recoger en la asociación seleccionada en un máximo de 3 días. El pago se realizará al momento de la entrega.";
        }
      }
      
      setPaymentStatus("success");
      setPaymentMessage(successMessage);
      setShowPaymentResult(true);
      
      // Limpiar el carrito después de mostrar el mensaje
      setOrderId(null);
      setOrderLines([]);

    } catch (error) {
      console.error("Error durante el pago:", error);
      alert("Ocurrió un error al procesar el pago. Intente nuevamente.");
    } finally {
      setIsProcessingPayment(false); // Libera botón
    }
  };

  const handleTiloPayRedirect = async (generateOrderNumber) => {
    try {
      const response = await fetch("http://localhost:8000/createPayment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: Number(total + (parseInt(pickupLocation) === 5 ? 2500 : 0)).toFixed(2),
          currency: "CRC",
          // customerName: tiloPayName // EJEMPLO DE USO
          customerName: user?.name || "Cliente",
          customerLastName: user?.lastName || "Volteon",
          customerEmail: user?.email || "soporte@volteon.com",
          customerPhone: String(user?.phone || "88888888"),
          orderNumber: generateOrderNumber,
          redirectUrl: window.location.origin + "/perfil",
        }),

      });

      const result = await response.json();
      if (result?.url) {
        window.location.href = result.url;
      } else {
        throw new Error("No se obtuvo URL de TiloPay");
      }
    } catch (err) {
      console.error("Error al conectar con TiloPay:", err);
      alert("Error al conectar con TiloPay.");
    }
  };

  const closePaymentDialog = () => {
    setShowPaymentResult(false);
    setPaymentStatus(null);
    setPaymentMessage("");

    // Si el pago fue exitoso, recargar la página para actualizar todo
    if (paymentStatus === 'success') {
      window.location.reload();
    }
  };

  const displaySection = displayThisSection(
    props.displayThis,
    false,
    orderLines.length
  );
  const displayMessageForEmpty = displayThisSection(
    props.displayThis,
    true,
    orderLines.length
  );

  return (
    <>
      {/* Dialog para mostrar resultado del pago */}
      <Dialog open={showPaymentResult} onClose={closePaymentDialog}>
        <DialogTitle style={{ textAlign: 'center' }}>
          {paymentStatus === 'success' && <CheckCircleIcon style={{ color: 'green', fontSize: 40, marginRight: 10 }} />}
          {paymentStatus === 'failed' && <ErrorIcon style={{ color: 'red', fontSize: 40, marginRight: 10 }} />}
          {paymentStatus === 'insufficient_funds' && <ErrorIcon style={{ color: 'orange', fontSize: 40, marginRight: 10 }} />}
          Resultado del Pago
        </DialogTitle>
        <DialogContent>
          <p style={{ textAlign: 'center', fontSize: 16 }}>
            {paymentMessage}
          </p>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button onClick={closePaymentDialog} color="primary" variant="contained">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      <div
        style={{
          display: displayMessageForEmpty,
          textAlign: "center",
          fontSize: "1.8rem",
          fontWeight: "bold",
          color: "#ff6b6b",
          padding: "2rem",
          fontFamily: "'Poppins', sans-serif",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
        className="empty-cart-block"
      >
        ¡Ups! No tienes nada en el carrito
      </div>
      <div style={{ display: displaySection }}>
        <div style={{ flexFlow: "column" }}>
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Su número de orden: {orderId || "Cargando..."}
          </div>
          <div
            style={{
              flexFlow: "column",
              maxHeight: "500px",
              overflowY: "auto",
              paddingRight: 50,
              paddingTop: "15px",
              overflowX: "hidden",
            }}
          >
            {orderLines.map((line, index) => (
              <CardShoppingCart
                key={index}
                productData={{
                  name: line.label,
                  quantity: line.qty,
                  price: line.total_ttc,
                  ref: line.line || "N/A",
                  src: line.imageUrl || "resis.jpg",
                }}
                orderId={orderId}
                index={index}
              />
            ))}
          </div>
          <Divider style={{ marginTop: "20px" }} />
          <div style={{ fontWeight: "bold", textAlign: "center" }}>
            Precio total: ₡{total.toFixed(0)}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ marginTop: "10px", maxWidth: "400px", width: "100%" }}>
              <Select
                value={pickupLocation}
                onChange={(e) => setPickupLocation(e.target.value)}
                displayEmpty
                fullWidth
                sx={aceternitySelectSx}
                MenuProps={{ PaperProps: { sx: aceternityMenuPaperSx } }}
              >
                <MenuItem value="" disabled>
                  Seleccione punto de entrega
                </MenuItem>
                <MenuItem value="5">
                  Correos de Costa Rica (Suma 2500₡ al precio final)
                </MenuItem>
                <MenuItem value="1">
                  Asocia de estudiantes de Computadores
                </MenuItem>
                <MenuItem value="2">
                  Asocia de estudiantes de Mecatrónica
                </MenuItem>
                <MenuItem value="4">
                  Asociación de estudiantes de Electrónica (Cartago)
                </MenuItem>
                <MenuItem value="6">
                  Asociación de estudiantes de Electrónica (San Carlos)
                </MenuItem>
              </Select>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ marginTop: "10px", maxWidth: "400px", width: "100%" }}>
              <Select
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                displayEmpty
                fullWidth
                sx={aceternitySelectSx}
                MenuProps={{ PaperProps: { sx: aceternityMenuPaperSx } }}
              >
                <MenuItem value="" disabled>
                  Seleccione método de pago
                </MenuItem>
                <MenuItem value="106">Sinpe Móvil</MenuItem>
                <MenuItem value="4">Efectivo</MenuItem>
                {/* <MenuItem value="6">Pago con Tarjeta</MenuItem> */}
              </Select>
            </div>
          </div>

          {/* Formulario de datos para TiloPay */}
          {paymentMethod === "6" && (
            <Box className="aceternity-summary" style={{ maxWidth: "400px", margin: "20px auto 0 auto" }}>
              <Typography variant="h6" style={{
                textAlign: "center",
                marginBottom: "15px",
                color: "#f2f2f2",
                fontWeight: "bold"
              }}>
                Para realizar el pago con Tarjeta, por seguridad necesitamos que complete los siguientes espacios:
              </Typography>

              <div className="aceternity-form-row">
                <TextField
                  fullWidth
                  label="Nombre *"
                  value={tiloPayName}
                  onChange={(e) => setTiloPayName(e.target.value)}
                  variant="filled"
                  size="small"
                  sx={aceternityTextFieldSx}
                />
              </div>

              <div className="aceternity-form-row">
                <TextField
                  fullWidth
                  label="Apellido *"
                  value={tiloPayLastName}
                  onChange={(e) => setTiloPayLastName(e.target.value)}
                  variant="filled"
                  size="small"
                  sx={aceternityTextFieldSx}
                />
              </div>

              <div className="aceternity-form-row">
                <TextField
                  fullWidth
                  label="Correo electrónico *"
                  type="email"
                  value={tiloPayEmail}
                  onChange={(e) => setTiloPayEmail(e.target.value)}
                  variant="filled"
                  size="small"
                  sx={aceternityTextFieldSx}
                />
              </div>

              <div className="aceternity-form-row">
                <TextField
                  fullWidth
                  label="Dirección *"
                  value={tiloPayAddress}
                  onChange={(e) => setTiloPayAddress(e.target.value)}
                  variant="filled"
                  size="small"
                  placeholder="Ej: 100 metros norte de la iglesia"
                  sx={aceternityTextFieldSx}
                />
              </div>

              <div className="aceternity-form-row">
                <Select
                  fullWidth
                  value={tiloPayProvince}
                  onChange={(e) => setTiloPayProvince(e.target.value)}
                  displayEmpty
                  sx={aceternitySelectSx}
                  MenuProps={{ PaperProps: { sx: aceternityMenuPaperSx } }}
                >
                  <MenuItem value="" disabled>
                    Seleccione su provincia *
                  </MenuItem>
                  {costaRicanProvinces.map((province) => (
                    <MenuItem key={province} value={province}>
                      {province}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="aceternity-form-row">
                <TextField
                  fullWidth
                  label="Código Postal *"
                  value={tiloPayPostalCode}
                  onChange={(e) => {
                    // Solo permitir números y máximo 5 dígitos
                    const value = e.target.value.replace(/\D/g, '').slice(0, 5);
                    setTiloPayPostalCode(value);
                  }}
                  variant="filled"
                  size="small"
                  placeholder="Ej: 10101"
                  helperText="Debe tener exactamente 5 dígitos"
                  sx={aceternityTextFieldSx}
                />
              </div>

              <Typography variant="caption" style={{
                display: "block",
                textAlign: "center",
                marginTop: "10px",
                color: "rgba(255,255,255,0.5)",
                fontStyle: "italic"
              }}>
                * Todos los campos son obligatorios
              </Typography>
            </Box>
          )}

          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <button
              className="aceternity-btn-primary"
              onClick={handlePayment}
              disabled={isProcessingPayment}
              style={{ maxWidth: "260px", margin: "0 auto" }}
            >
              <ShoppingCartCheckoutIcon sx={{ fontSize: 22 }} />
              {isProcessingPayment
                ? "Procesando..."
                : paymentMethod === "6"
                  ? "Pagar con Tarjeta"
                  : "Pagar"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardListShoppingCart;